"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const big_js_1 = __importDefault(require("big.js"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcWorksheetWorkItems = class UcWorksheetWorkItems extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onServiceSelected(...args) {
        const [row, service] = args;
        row.service = service;
        row.service_id = service.id;
        row.unit = service.unit;
        row.task = service.name;
        row.tax_code = service.sales_vat_code;
        row.intermediated_service = service.intermediated_service || false;
        row.setFocus('quantity');
    }
    onServiceChanged(...args) {
        console.log('onServiceChanged', args);
    }
    calculateUnitPrice(...args) {
        const [row, tax, decimals] = args;
        row.unit_price = (0, big_js_1.default)((0, big_js_1.default)(row.net_amount) / (0, big_js_1.default)(row.quantity) / (1 - (0, big_js_1.default)(row.discount) / 100)).round(decimals).toNumber();
    }
    calculateNetAmount(...args) {
        const [row, tax, decimals] = args;
        row.net_amount = (0, big_js_1.default)((0, big_js_1.default)(row.quantity) * (0, big_js_1.default)(row.unit_price) * (1 - (0, big_js_1.default)(row.discount) / 100)).round(decimals).toNumber();
    }
    calculateNetAmountFromAmount(...args) {
        const [row, tax, decimals] = args;
        row.net_amount = (0, big_js_1.default)((0, big_js_1.default)(row.amount) / (1 + (0, big_js_1.default)(tax.rate) / 100)).round(decimals).toNumber();
    }
    calculateAmount(...args) {
        const [row, tax, decimals] = args;
        row.amount = (0, big_js_1.default)((0, big_js_1.default)(row.net_amount) * (1 + (0, big_js_1.default)(tax.rate) / 100)).round(decimals).toNumber();
    }
    recalculateLineItem(...args) {
        const data = args[0].data;
        const row = data.row;
        const decimals = 2;
        const tx = _.find(this.taxCodes, { id: row.tax_code });
        if (row.quantity === 0) {
            return;
        }
        switch (data.field) {
            case 'quantity':
            case 'unit_price':
            case 'discount': {
                this.calculateNetAmount(row, tx, decimals);
                this.calculateAmount(row, tx, decimals);
                break;
            }
            case 'net_amount': {
                this.calculateUnitPrice(row, tx, decimals);
                this.calculateAmount(row, tx, decimals);
                break;
            }
            case 'tax_code': {
                this.calculateAmount(row, tx, decimals);
                break;
            }
            case 'amount': {
                this.calculateNetAmountFromAmount(row, tx, decimals);
                this.calculateUnitPrice(row, tx, decimals);
                break;
            }
        }
    }
    worksheet;
    onWorksheet(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("worksheet");
    }
    isReadonly;
    onIs_readonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("isReadonly");
    }
    expenseTypes;
    async $$load_expenseTypes() {
        return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'expense-type' } });
    }
    taxCodes;
    async $$load_taxCodes() {
        return this.$fn.fetch('list_tax_code');
    }
    units;
    async $$load_units() {
        return this.$fn.fetch('list_unit');
    }
    ux;
    b_5962862420439144_rowHeader;
    b_5962862420439144_paging;
    b_5962862420439144_sortable;
    b_5962862420439144_columns;
    async $$load_b_5962862420439144_columns() {
        return [{
                name: "service",
                type: "select2",
                header: this.$fn.gettext("Task"),
                width: "140px",
                formatter: {
                    name: "template",
                    value: "<b-link :to=\"{\n\
  name: 'app.product',\n\
  params: { id: row.service_id }\n\
}\">{{ row.task }}</b-link>\n\
",
                },
                options: this.$fn.searchDataSource('suggest_product', { parameters: { product_types: 'service' } }),
                optionValueField: "name",
                valueField: "id",
                textField: "name",
                bindObject: true,
                validator: ["required",
                ],
            },
            {
                name: "asset",
                type: "select2",
                header: this.$fn.gettext("Asset"),
                width: "140px",
                formatter: {
                    name: "template",
                    value: "<b-link :to=\"{\n\
  name: 'app.fixedAsset',\n\
  params: { id: row.asset_id }\n\
}\">{{ row.asset ? row.asset.name : '-' }}</b-link>\n\
",
                },
                options: this.$fn.searchDataSource('suggest_fixed_asset'),
                optionValueField: "name",
                valueField: "id",
                textField: "name",
                bindObject: true,
            },
            {
                name: "date",
                type: "date",
                header: this.$fn.gettext("Date"),
                width: "140px",
                required: true,
            },
            {
                name: "notes",
                type: "textarea",
                width: "200px",
                header: this.$fn.gettext("Notes"),
            },
            {
                name: "quantity",
                type: "number",
                default: 0,
                header: this.$fn.pgettext("Quantity Abbr", "Qty"),
                headerTooltip: this.$fn.gettext("Quantity"),
                width: "60px",
                textAlign: "right",
                required: true,
                editorIsDisabled: row => !row.service || !row.service.id,
            },
            {
                name: "unit",
                header: this.$fn.pgettext("Unit Abbr", "Unit"),
                headerTooltip: this.$fn.gettext("Unit"),
                width: "70px",
                textAlign: "center",
                required: true,
                editorIsDisabled: row => !row.service || !row.service.id,
            },
            {
                name: "unit_price",
                type: "number",
                default: 0,
                header: this.$fn.gettext("Price"),
                width: "70px",
                textAlign: "right",
                required: true,
                editorIsDisabled: row => !row.service || !row.service.id,
            },
            {
                name: "discount",
                type: "number",
                default: 0,
                header: this.$fn.pgettext("AbbrDiscount", "Disc"),
                headerTooltip: this.$fn.gettext("Discount"),
                width: "70px",
                required: true,
                editorIsDisabled: row => !row.service || !row.service.id,
            },
            {
                name: "net_amount",
                type: "number",
                default: 0,
                header: this.$fn.gettext("Net"),
                width: "100px",
                textAlign: "right",
                required: true,
                editorIsDisabled: row => !row.service || !row.service.id,
            },
            {
                name: "amount",
                type: "number",
                default: 0,
                header: this.$fn.gettext("Amount"),
                width: "100px",
                textAlign: "right",
                required: true,
                editorIsDisabled: row => !row.service || !row.service.id,
            },
            {
                name: "tax_code",
                header: this.$fn.gettext("VAT"),
                headerTooltip: this.$fn.gettext("VAT Code"),
                width: "100px",
                type: "select",
                options: this.taxCodes,
                valueField: "id",
                textField: "id",
                editorIsDisabled: row => !row.service || !row.service.id,
            },
            {
                name: "intermediated_service",
                header: this.$fn.pgettext("AbbrIntermediatedService", "IMS"),
                headerTooltip: this.$fn.gettext("Intermediated Service"),
                width: "60px",
                type: "checkbox",
                editorIsDisabled: row => !row.service || !row.service.id,
            },
        ];
    }
    dataMembers = ['expenseTypes', 'taxCodes', 'units', 'ux', 'b_5962862420439144_rowHeader', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                expenseTypes: null,
                taxCodes: null,
                units: null,
                ux: {
                    errorHandling: "local",
                    initialLoadSpinner: true,
                },
                b_5962862420439144_rowHeader: false,
                b_5962862420439144_paging: false,
                b_5962862420439144_sortable: false,
                b_5962862420439144_columns: null,
            },
        };
    }
    async act_5962862420439144_emit_8136_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5962862420439144_saveCompleted(event, scope) {
        return await this.actions.evh_5962862420439144_saveCompleted.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8138_getActionArgs_value($event) {
        this.worksheet.id
            ? $event.data.waitFor(this.$fn.crud('work_item').upsert({ ...$event.data.row, worksheet_id: this.worksheet.id }))
            : this.worksheet.work_items.splice(this.worksheet.work_items.length - 1, 0, $event.data.row);
    }
    async act_5962862420439144_script_8138_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8138_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_save(event, scope) {
        return await this.actions.evh_5962862420439144_save.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8140_getActionArgs_value($event) {
        this.worksheet.id
            ? $event.data.waitFor(this.$fn.crud('work_item').delete($event.data.row))
            : _.remove(this.worksheet.work_items, $event.data.row);
    }
    async act_5962862420439144_script_8140_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8140_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_delete(event, scope) {
        return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8142_getActionArgs_value($event) {
        this.onServiceSelected($event.data.row, $event.data.option);
    }
    async act_5962862420439144_script_8142_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8142_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_serviceSelected(event, scope) {
        return await this.actions.evh_5962862420439144_serviceSelected.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8144_getActionArgs_value($event) {
        this.onServiceChanged($event);
    }
    async act_5962862420439144_script_8144_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8144_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_serviceChange(event, scope) {
        return await this.actions.evh_5962862420439144_serviceChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8146_getActionArgs_value($event) {
        this.recalculateLineItem($event);
    }
    async act_5962862420439144_script_8146_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8146_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_quantityChange(event, scope) {
        return await this.actions.evh_5962862420439144_quantityChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8148_getActionArgs_value($event) {
        this.recalculateLineItem($event);
    }
    async act_5962862420439144_script_8148_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8148_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_unitPriceChange(event, scope) {
        return await this.actions.evh_5962862420439144_unitPriceChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8150_getActionArgs_value($event) {
        this.recalculateLineItem($event);
    }
    async act_5962862420439144_script_8150_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8150_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_discountChange(event, scope) {
        return await this.actions.evh_5962862420439144_discountChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8152_getActionArgs_value($event) {
        this.recalculateLineItem($event);
    }
    async act_5962862420439144_script_8152_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8152_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_netAmountChange(event, scope) {
        return await this.actions.evh_5962862420439144_netAmountChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8154_getActionArgs_value($event) {
        this.recalculateLineItem($event);
    }
    async act_5962862420439144_script_8154_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8154_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_amountChange(event, scope) {
        return await this.actions.evh_5962862420439144_amountChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8156_getActionArgs_value($event) {
        this.recalculateLineItem($event);
    }
    async act_5962862420439144_script_8156_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8156_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_taxCodeChange(event, scope) {
        return await this.actions.evh_5962862420439144_taxCodeChange.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_emit_8136 = new core_1.actions.EmitAction({
            actionArgs: this.act_5962862420439144_emit_8136_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_saveCompleted_8135 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_emit_8136,
            event: "save-completed",
            displayName: "emit",
        });
        const evh_5962862420439144_saveCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_saveCompleted_8135],
        });
        const act_5962862420439144_script_8138 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8138_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_save_8137 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8138,
            event: "save",
            displayName: "script",
        });
        const evh_5962862420439144_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_save_8137],
        });
        const act_5962862420439144_script_8140 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8140_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_delete_8139 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8140,
            event: "delete",
            displayName: "script",
        });
        const evh_5962862420439144_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_delete_8139],
        });
        const act_5962862420439144_script_8142 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8142_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_serviceSelected_8141 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8142,
            event: "service:selected",
            displayName: "script",
        });
        const evh_5962862420439144_serviceSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_serviceSelected_8141],
        });
        const act_5962862420439144_script_8144 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8144_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_serviceChange_8143 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8144,
            event: "service:change",
            displayName: "script",
        });
        const evh_5962862420439144_serviceChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_serviceChange_8143],
        });
        const act_5962862420439144_script_8146 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8146_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_quantityChange_8145 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8146,
            event: "quantity:change",
            displayName: "script",
        });
        const evh_5962862420439144_quantityChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_quantityChange_8145],
        });
        const act_5962862420439144_script_8148 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8148_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_unitPriceChange_8147 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8148,
            event: "unit_price:change",
            displayName: "script",
        });
        const evh_5962862420439144_unitPriceChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_unitPriceChange_8147],
        });
        const act_5962862420439144_script_8150 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8150_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_discountChange_8149 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8150,
            event: "discount:change",
            displayName: "script",
        });
        const evh_5962862420439144_discountChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_discountChange_8149],
        });
        const act_5962862420439144_script_8152 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8152_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_netAmountChange_8151 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8152,
            event: "net_amount:change",
            displayName: "script",
        });
        const evh_5962862420439144_netAmountChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_netAmountChange_8151],
        });
        const act_5962862420439144_script_8154 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8154_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_amountChange_8153 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8154,
            event: "amount:change",
            displayName: "script",
        });
        const evh_5962862420439144_amountChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_amountChange_8153],
        });
        const act_5962862420439144_script_8156 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8156_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_taxCodeChange_8155 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8156,
            event: "tax_code:change",
            displayName: "script",
        });
        const evh_5962862420439144_taxCodeChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_taxCodeChange_8155],
        });
        return {
            act_5962862420439144_emit_8136,
            evh_5962862420439144_saveCompleted_8135,
            evh_5962862420439144_saveCompleted,
            act_5962862420439144_script_8138,
            evh_5962862420439144_save_8137,
            evh_5962862420439144_save,
            act_5962862420439144_script_8140,
            evh_5962862420439144_delete_8139,
            evh_5962862420439144_delete,
            act_5962862420439144_script_8142,
            evh_5962862420439144_serviceSelected_8141,
            evh_5962862420439144_serviceSelected,
            act_5962862420439144_script_8144,
            evh_5962862420439144_serviceChange_8143,
            evh_5962862420439144_serviceChange,
            act_5962862420439144_script_8146,
            evh_5962862420439144_quantityChange_8145,
            evh_5962862420439144_quantityChange,
            act_5962862420439144_script_8148,
            evh_5962862420439144_unitPriceChange_8147,
            evh_5962862420439144_unitPriceChange,
            act_5962862420439144_script_8150,
            evh_5962862420439144_discountChange_8149,
            evh_5962862420439144_discountChange,
            act_5962862420439144_script_8152,
            evh_5962862420439144_netAmountChange_8151,
            evh_5962862420439144_netAmountChange,
            act_5962862420439144_script_8154,
            evh_5962862420439144_amountChange_8153,
            evh_5962862420439144_amountChange,
            act_5962862420439144_script_8156,
            evh_5962862420439144_taxCodeChange_8155,
            evh_5962862420439144_taxCodeChange,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcWorksheetWorkItems.prototype, "worksheet", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('worksheet'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcWorksheetWorkItems.prototype, "onWorksheet", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcWorksheetWorkItems.prototype, "isReadonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isReadonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcWorksheetWorkItems.prototype, "onIs_readonly", null);
UcWorksheetWorkItems = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcWorksheetWorkItems);
exports.default = UcWorksheetWorkItems;
vue_property_decorator_1.Vue.component("UcWorksheetWorkItems", UcWorksheetWorkItems);
